// extracted by mini-css-extract-plugin
export default {"image":"ResetPassword_image__HtG9w","logo":"ResetPassword_logo__wYOMo","form":"ResetPassword_form__opDFD"};